import { apiClient } from '@/plugins/http'

export const downloadExcelFile = async (url) => {
  const response = await apiClient.get(url, {
    responseType: 'blob',
  })

  const { data, status } = response

  if (status !== 200) {
    throw new Error('Failed to download file')
  }

  const blob = new Blob([data], { type: 'application/vnd.ms-excel' })
  const objectUrl = window.URL.createObjectURL(blob)

  const a = document.createElement('a')
  a.href = objectUrl
  a.download = 'data.xls'
  document.body.appendChild(a)
  a.click()
  a.remove()
  window.URL.revokeObjectURL(objectUrl)
}
